var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.props.className,style:(this.props.style)},[_c('img',{ref:"elementRef",style:(this.props.imageStyle),attrs:{"src":_vm.model[_vm.modelKey],"width":this.props.width,"height":this.props.height},on:{"click":_vm.clickHandle}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9d4b8c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ImageComponent.vue
// module id = null
// module chunks = 